/** 当前滚动章节，范围为 1～13；由 FlyingCamera 写入，DOM 和菜单读取。 */
import { atom, useRecoilState } from 'recoil';

const screensState = atom<number>({
    key: 'screensState',
    default: 1,
});

export const useScreensState = () => useRecoilState(screensState);
